import { Helmet } from 'react-helmet-async';
import PageBanner from '@components/Common/PageBanner';
import TeamSection from '@components/About/TeamSection';
import Statistics from '@components/About/Statistics';
import Testimonials from '@components/Common/Testimonials';

const About = () => {
    return (
        <>
            <Helmet>
                <title>About Us - Abhishek Tamakuwala Architects</title>
                <meta name="description" content="Learn about our team and our journey in architecture" />
            </Helmet>

            <PageBanner
                title="About Us"
                subtitle="Everything you need to know about our Company"
                backgroundImage="/images/about-us.jpg"
            />

            <Statistics />
            <TeamSection />
            <Testimonials />
        </>
    );
};

export default About;